<template>
<div>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<h1 class="page-header">Flächenarten</h1>
			</div>
		</div>

		<custom-table edit add delete @edit="editCat" @add="newCat" @delete="removeCat" :src-model="$store.getters.models('categories')" :cols="model.cols" store="categories" search :default-sort="defSort"></custom-table>
	</div>

	<custom-modal v-if="showModal" :title="modalTitle" ok-text="Speichern" cancel-text="Abbrechen" @cancel="showModal = false" @ok="quitModal" cancel-style="btn btn-default">
		<custom-input inline>
			<label class="col-sm-12 control-label" for="name">Bezeichnung</label>
			<div class="col-sm-12">
				<input name="name" class="form-control" required="required" v-model="model.model.name">
			</div>
		</custom-input>

		<custom-input inline>
			<label class="col-sm-12 control-label" for="price">Preis</label>
			<div class="col-sm-12">
				<input name="price" id="price" class="form-control" required="required" v-model="model.model.price" type="number">
			</div>
		</custom-input>

		<custom-input inline>
			<label class="col-sm-12 control-label" for="short_name">Kürzel</label>
			<div class="col-sm-12">
				<input name="short_name" class="form-control" required="required" v-model="model.model.short_name">
			</div>
		</custom-input>
	</custom-modal>
</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'

import Category from 'models/categories.js'

import modelTools from 'functions/models.js'
import { authCheck } from 'functions/auth_check.js'

export default {
  beforeRouteEnter (to, from, next) {
    const route = authCheck('area_categories')
    if (route === null) {
      next()
    } else {
      next(route)
    }
  },

	// Normale Eigenschaften
	data () {
		return {
			model: Category,

			defSort: { col: 'name', order: 'asc' },

			showModal: false,
			modalTitle: ''
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomInput
	},

	activated () {
		this.$store.dispatch('loadModel', 'categories')
	},

	methods: {
		// Tools des Models
		saveModel: modelTools.save,
		removeModel: modelTools.remove,

		editCat (aModel) {
			this.model.copy(aModel)
			this.showModal = true
			this.modalTitle = 'Kategorie bearbeiten'
		},

		newCat () {
			this.model.clear()
			this.showModal = true
			this.modalTitle = 'Kategorie anlegen'
		},

		removeCat (aModel) {
			this.model.copy(aModel)
			this.removeModel()
		},

		quitModal () {
		    this.saveModel()
		    this.showModal = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// AreaCategories.vue?adad113a